<template>
  <div class="elementSpace">
    <div class="firstContent">
      <span class="titre">Liste de données</span>
      <draggable
        class="list-group"
        tag="ul"
        v-model="list"
        v-bind="dragOptions"
        :move="onMove"
        @start="isDragging = true"
        @end="isDragging = false"
      >
        <!-- <img v-if="list.length == 0" src="../assets/emptyListe.png" alt=""> -->
        <transition-group type="transition" :name="'flip-list'">
          <li
            class="list-group-item"
            v-for="element in list"
            :key="element.order"
          >
            {{ element.name }}
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="firstContent">
      <span class="titre">Liste de données Excel</span>
      <draggable
        element="span"
        v-model="list2"
        v-bind="dragOptions"
        :move="onMove"
      >
        <transition-group class="list-group" name="no" tag="ul">
          <li
            class="list-group-item"
            v-for="element in list2"
            :key="element.order"
          >
            <span
              @click="element.fixed = !element.fixed"
              class="material-icons-sharp myIcons"
            >
              {{ element.fixed ? "anchor" : "push_pin" }}
            </span>

            {{ element.name }}
          </li>
        </transition-group>
      </draggable>
    </div>

    <!-- <div class="list-group col-md-3">
      <pre>{{listString}}</pre>
    </div>
    <div class="list-group col-md-3">
      <pre>{{list2String}}</pre>
    </div> -->
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  props: {
    dataJson: {
      type: Object, // Type de la valeur que vous attendez
      required: true, // Indique que cette prop est requise
    },
  },
  name: "statExport",
  components: {
    draggable,
  },
  data() {
    return {
      list: [],
      list2: [],
      editable: true,
      isDragging: false,
      delayedDragging: false,
    };
  },
  methods: {
    orderList() {
      this.list = this.list.sort((one, two) => {
        return one.order - two.order;
      });
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
  },
  mounted() {
    // alert("mounted");
    // Initialiser list avec les données actuelles de dataJson.order
    if (this.dataJson && this.dataJson.order) {
      this.list = this.dataJson.order;
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
    listString() {
      return JSON.stringify(this.list, null, 2);
    },
    list2String() {
      return JSON.stringify(this.list2, null, 2);
    },
  },
  watch: {
    list2(){
        this.$emit("dataRealOrderChange", this.list2);
    },
    dataJson: {
      handler(newData, oldData) {
        // Vérifiez si dataJson.order existe et est différent de l'ancienne valeur
        if (newData && newData.order && newData.order !== oldData.order) {
          // Assigner la nouvelle valeur à list
          this.list = newData.order;
          // Afficher une alerte pour indiquer que les données ont été mises à jour
          // alert("Data updated");
        }
      },
      deep: true, // Surveille également les changements dans les propriétés des objets imbriqués
    },
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>
